import React, { useEffect, useRef, useState } from 'react';
import { useSelector } from 'react-redux';
import { useDispatch } from 'react-redux';
import { fetchAdminGetSingleTicket } from '../../../../redux/action/tickets/adminGetSingleTicket';
import default_image_url from '../../../../redux/api/API';
import MainLoading from '../../../../utils/MainLoading';
import DashboardMainTitle from '../../../dashboardTitle/DashboardMainTitle';
import moment from "moment-jalaali";
import './style.scss'
import { Button, Form, Modal, Row } from 'react-bootstrap';
import SimpleReactValidator from 'simple-react-validator';
import { fetchCsrfCookie } from '../../../../redux/action/csrf/csrf-cookie';
import axios from 'axios';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';

const CompanySingleTicket = (props) => {
    const {t} = useTranslation();
    const [btnLoading, setBtnLoading] = useState(false)
    const [forceUpdate, setForceUpdate] = useState(0)
    const [ticket, setTicket] = useState({})
    const [messages, setMessages] = useState([])
    const [message, setMessage] = useState('')
    const [photo, setPhoto] = useState('')
    const [uploadPercentage, setUploadPercentage] = useState(0)
    const [progerssbar, setProgressbar] = useState(0)
    const [selectedImage, setSelectedImage] = useState();
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const lang = localStorage.getItem('lang')

    const handleSelectImage = (e) => {
        if (e.target.files && e.target.files.length > 0) {
            setSelectedImage(e.target.files[0]);
        }
        setPhoto(e.target.files[0])
    }

    const removeSelectedImage = () => {
        setSelectedImage();
        setPhoto()
    }

    const dispatch = useDispatch()
    const SingleTicket = useSelector(state => state.adminSingleTicket)

    useEffect(() => {
        dispatch(fetchAdminGetSingleTicket(props.id))
    }, [])

    useEffect(() => {
        setTicket(SingleTicket.admin_single_ticket.ticket)
        SingleTicket.admin_single_ticket.messages && setMessages(SingleTicket.admin_single_ticket.messages.reverse())
    } , [SingleTicket.admin_single_ticket])
    
    const validator = useRef(new SimpleReactValidator({
        messages: {
          required:"پر کردن این فیلد الزامی است"
        },
    }))

    const handleResponse = (e) => {
        setMessage(e.target.value)
    }

    const handleSubmit = (e) => {
        e.preventDefault()
        setBtnLoading(true)
        if (validator.current.allValid()) {
            setProgressbar(true)
            setBtnLoading(false)
            dispatch(fetchCsrfCookie())

            const formData = new FormData();
            formData.append('message', message)
            formData.append('files[]', photo)

            const config = {
                headers: { 'Content-Type': 'multipart/form-data' },

                onUploadProgress: (progressEvent) => {
                    const {loaded, total} = progressEvent;
                    let percent = Math.floor( (loaded * 100) / total )
            
                    if( percent < 100 ){
                        setUploadPercentage(percent)
                    }
                }
            }

            axios.post(`admin/tickets/${props.id}/message`, formData, config)
            .then(res => {
                setUploadPercentage(100)
                setTimeout(() => {
                    setUploadPercentage(0)
                }, 1000);
                setPhoto()
                setSelectedImage()
                toast.dismiss()	
                toast.success(t("toast_successfully_sent") , {position: 'bottom-right',className: 'foo-bar'})
                window.scrollTo(0, 0)
                setMessage('')
                setTimeout(function(){
                    dispatch(fetchAdminGetSingleTicket(props.id))
                }, 500)

            })
            .catch(err => {
                setBtnLoading(false)
                console.log(err)
                if(err.response) {
                    if(err.response.status === 403) {
                        setPhoto()
                        setSelectedImage()
                        setProgressbar()
                        toast.dismiss()
                        toast.error(t("toast_content_not_valid") , {position: 'bottom-right',className: 'foo-bar'})
                    } else {
                        setPhoto()
                        setSelectedImage()
                        setProgressbar()
                        toast.dismiss()
                        toast.error(t("toast_something_went_wrong") , {position: 'bottom-right',className: 'foo-bar'})
                    }
                }
            })
        } else {
            setBtnLoading(false)
            setForceUpdate(1)
            validator.current.showMessages()
            toast.dismiss()
            toast.error(t("toast_please_fill_in_all_fields") , {position: 'bottom-right',className: 'foo-bar'})
        }
    }

    const closeTicket = () => {
        setShow(true)
    }

    const handleCloseTicket = () => {
        setBtnLoading(true)
        axios.post(`co/tickets/${props.id}`)
        .then(res => {
            setBtnLoading(false)
            setPhoto()
            toast.success(`تیکت با موفقیت بسته شد` , {position: 'bottom-right',className: 'foo-bar'})
            window.scrollTo(0, 0)
            setMessage('')
            setTimeout(function(){
                dispatch(fetchAdminGetSingleTicket(props.id))
            }, 500)
            setShow(false)
        })
        .catch(err => {
            setBtnLoading(false)
            console.log(err)
        })
    }

  return (
    <>
        <div className='d-flex justify-content-end mb-3'>
            <button className='btn btn-primary' onClick={props.close}>{t("dashboard_nav_tickets")}</button>
        </div>
        {SingleTicket.loading ?
            <MainLoading />
        :
            ticket &&
            <>
                <DashboardMainTitle>{ticket.subject}</DashboardMainTitle>
                <div className='messages'>
                    {messages.map(msg => (
                        <div className={msg.user.role === "ADMIN-CO" ? 'message' : 'answer'} key={msg.id}>
                            <div className='ticket_header'>
                                <div className='ticket_header_image'>
                                    {msg.user.avatar ?
                                        <img src={default_image_url+msg.user.avatar} alt="user" style={{borderRadius: '50%'}} />
                                    :
                                        <img src='/assets/img/shop.png' alt="user" style={{borderRadius: '0%'}} />
                                    }
                                </div>
                                <h6>{msg.user.title}</h6>
                            </div>
                            <div className='ticket_content'>
                                <p>{msg.message}</p>
                                <div className='attachs'>
                                {msg.uploads.length ?
                                    <>
                                    <p>{t("attachments")} :</p>
                                    {msg.uploads.map(attachment => (
                                        <a href={default_image_url+attachment.path} target='_blank' key={attachment.id}>
                                            <img key={attachment.id} src={default_image_url+attachment.path} />
                                        </a>
                                    ))}
                                    </>
                                :
                                    ''
                                }
                                </div>
                                
                                <span>
                                    {lang === 'en' ?
                                        msg.created_at.substr(11, 5)+' - '+msg.created_at && msg.created_at.substr(0, 10)
                                    :
                                        msg.created_at.substr(11, 5)+' - '+moment(msg.created_at && msg.created_at.substr(0, 10), 'YYYY-M-D').format('jYYYY/jM/jD')
                                    }
                                </span>
                            </div>
                        </div>
                    ))}
                </div>
                {
                ticket.state === "CLOSED" ?
                    <h6 className='response text-center mt-5'>{t("The ticket is closed")}</h6>
                :
                    <>
                        <div className='response col-lg-12 mt-5'>
                            <Form onSubmit={handleSubmit}>
                                <Form.Group className="col-lg-7 mb-3" controlId="exampleForm.ControlTextarea1">
                                    <Form.Label>{t("create new ticket")} :</Form.Label>
                                    <Form.Control as="textarea" rows={3} name="message" value={message} onChange={ e => handleResponse(e)} />
                                    <span className='validator_error'>{validator.current.message('message', message, 'required')}</span>
                                </Form.Group>
                                <Row>
                                    <div className='mt-4'>
                                        <p>{t("The maximum accepted image size is 2 MB")}</p>
                                        <p>{t("The_selected_image_format_must_be_one_of_the_following_jpeg_png_jpg_gif_svg")}</p>
                                    </div>
                                    {selectedImage ? 
                                        <div className='selectedImage col-lg-3'>
                                            <img
                                                src={URL.createObjectURL(selectedImage)}
                                                alt="Thumb"
                                            />
                                            <button className='btn btn-danger remove_selected_image' type='button' onClick={removeSelectedImage}>
                                                <i className='fa fa-times'></i>
                                            </button>
                                        </div>
                                    :
                                        <div className='selectImage col-lg-3'>
                                            <div className='chooseForm'>
                                                <input type="file" className='create_new_image_input' name="photo" value={photo} onChange={handleSelectImage}/>
                                                <i className='fa fa-plus'></i>
                                                <span>{t("choose picture")}</span>
                                            </div>
                                        </div>
                                    }
                                    
                                </Row>
                                <div className='d-flex justify-content-end'>
                                    <button className='btn btn-danger' type="button" onClick={closeTicket}> {t("close ticket")} </button>
                                    <button className='btn btn-success px-4 mx-2' type='submit' disabled={btnLoading ? true : false}>
                                        {t("send")}
                                    </button>
                                </div>
                            </Form>
                        </div>
                    </>
                }
            </>
        }

        {
            <Modal show={show} onHide={handleClose}>
                <Modal.Header closeButton>
                <Modal.Title>{t("close ticket")}</Modal.Title>
                </Modal.Header>
                <Modal.Body>{t("close this ticket")}</Modal.Body>
                <Modal.Footer>
                <Button variant="secondary" onClick={handleClose}>
                    {t("Cancel")}
                </Button>
                <Button variant="primary" onClick={handleCloseTicket} disabled={btnLoading ? true : false}>
                    {t("confirm")}
                </Button>
                </Modal.Footer>
          </Modal>
        }
    </>
  )
};

export default CompanySingleTicket;
